import { create } from 'zustand';
import type { Integration } from './integration-types';

interface IntegrationState {
  integrations: Integration[];
  providers: any[];
  loading: boolean;
  error: string | null;
  setIntegrations: (integrations: Integration[]) => void;
  addIntegration: (integration: Integration) => void;
  updateIntegration: (id: string, data: Partial<Integration>) => void;
  removeIntegration: (id: string) => void;
  setProviders: (providers: any[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useIntegrationStore = create<IntegrationState>((set) => ({
  integrations: [],
  providers: [],
  loading: false,
  error: null,
  setIntegrations: (integrations) => set({ integrations }),
  setProviders: (providers) => set({ providers }),
  addIntegration: (integration) => set((state) => ({ integrations: [...state.integrations, integration] })),
  updateIntegration: (id, data) =>
    set((state) => ({
      integrations: state.integrations.map((i) => (i.id === id ? { ...i, ...data } : i)),
    })),
  removeIntegration: (id) =>
    set((state) => ({
      integrations: state.integrations.filter((i) => i.id !== id),
    })),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
